import React, {useEffect, useRef, useState} from "react";
import mapboxgl from 'mapbox-gl';
import { makeStyles } from '@material-ui/core/styles';
import { createPortal } from "react-dom";
import MarcadorGoT from "./Marcador2";
import 'mapbox-gl/dist/mapbox-gl.css';
 
const useStyles = makeStyles({
    miclase:{".map-container":{
        height: "400px",
      }},
  });
 

function Mapa({lista, setLista, setActualiza,contador, setContador  }) {

    
    const classes = useStyles();
    const mapContainer = useRef(null);
    const mapRef = useRef(null);
    const markerRef = useRef()
    const [long] = useState(-101.3899294); 
    const [lat] = useState(23.4943939);
    const [zoom] = useState(8);        
    const [regisSelect, setRegisSelect] = useState([]);
   
    const [regisPopUp, setRegisPopUp] = useState([]);
    const [hoveredDistrict, _setHoveredDistrict] = useState(null);
     
    let hoveredStateId = null;
    let stateName = null;

 
    useEffect(() => {       
        //console.log(typeof lista, lista);
        
        mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_KEY;
        mapRef.current = new mapboxgl.Map({
            container: mapContainer.current,
            style: "mapbox://styles/mapbox/light-v10",
            center: [long, lat],
            zoom: zoom            
        });

         
        //mapRef.addControl(new mapboxgl.NavigationControl());
        mapRef.current.on('click', (e) => {                
            e.preventDefault()
            let nvoMarcador=[]
            //nvoMarcador=regisSelect           
            const geometry = { coordinates:[e.lngLat.lng.toFixed(5), e.lngLat.lat.toFixed(5)] } 
            const properties = {texto:"prueba"}    
            nvoMarcador= {geometry,properties,original:{Id:contador}}
           // console.log( contador, nvoMarcador);
            let auxLocalStg =  localStorage.getItem('auxPol') ?  JSON.parse(localStorage.getItem('auxPol')):[]
            if (auxLocalStg.length!==0) {
                //console.log(auxLocalStg);
                
                auxLocalStg.push(nvoMarcador)
                localStorage.setItem('auxPol',JSON.stringify(auxLocalStg))
            }
            else{
                localStorage.setItem('auxPol',JSON.stringify([nvoMarcador]))
            }
            
            setActualiza()
            setContador(contador+1)               
        });
        setRegisSelect(lista)
        return () => {
            mapRef.current.remove()
        }
    }, [    ]);

    useEffect(()=>{
       if (regisSelect.length!==0) {
        const auxCoordenadas=[]
        regisSelect.forEach((registro)=>{
            auxCoordenadas.push({... registro.geometry.coordinates})
        })
        mapRef.current.on('load', () => {
            // Add a data source containing GeoJSON data.
            mapRef.current.addSource('maine', {
                'type': 'geojson',
                'data': {
                    'type': 'Feature',
                    'geometry': {
                        'type': 'LineString',
                        // These coordinates outline Maine.
                        'coordinates': 
                            auxCoordenadas
                        
                    }
                }
            });
            mapRef.current.addLayer({
                'id': 'maine',
                'type': 'line',
                'source': 'maine', // reference the data source
                'layout': {'line-join': 'round',
          'line-cap': 'round'},
                'paint': {
                    'line-color': '#0080ff', // blue color fill
                    'line-width': 8
                }
            }); 
            // Add a new layer to visualize the polygon.
           /*  mapRef.current.addLayer({
                'id': 'maine',
                'type': 'fill',
                'source': 'maine', // reference the data source
                'layout': {},
                'paint': {
                    'fill-color': '#0080ff', // blue color fill
                    'fill-opacity': 0.5
                }
            });
            // Add a black outline around the polygon.
            mapRef.current.addLayer({
                'id': 'outline',
                'type': 'line',
                'source': 'maine',
                'layout': {},
                'paint': {
                    'line-color': '#000',
                    'line-width': 3
                }
            }); */
            });
        }
 
    },[regisSelect ])

    const onClick=(aux)=>{
        
        setRegisPopUp(aux)
    }

    return (
    <div className={classes.miclase} style={{width:800,height: "15rem"}} >
       
        {<div id="districtDetailMap" className={"map"} >
            <div style={{width:800,height: 450}} ref={mapContainer}>
            </div>
   
           {    regisSelect.length !== 0 ?
                regisSelect.map((elemento)=>
                    <MarcadorGoT
                    key={elemento.original.Id}
                    map={mapRef.current}
                    feature={elemento}
                    onClick={()=>{}}
                /> 
                )
               
          :null  }
           
        </div>}
    </div>
    );
}

export default Mapa;